/**
 * handlePincodeChange
 *
 * Handles pincode input changes in a Formik form, fetches pincode details, and updates form fields accordingly.
 *
 * Features:
 * - Resets district, state, and response fields on change
 * - Fetches pincode details when input length is 6 or more
 * - Updates form fields with API response (district, state, pincode_id)
 * - Handles success and error states for pincode validation
 *
 * @param {Object} formik - Formik form instance
 * @param {Function} getPincodeDetail - API function to fetch pincode details
 * @param {Object} e - Event object from input change
 */

export const handlePincodeChange = async (formik, getPincodeDetail, e) => {
    formik.setFieldValue('district', '');
    formik.setFieldValue('state', '');
    formik.setFieldValue('pincode_reponse', 'Processing...');
    formik.setFieldValue('pincode', e.target.value);

    if (e.target.value.length >= 6) {
        try {
            const res = await getPincodeDetail({ pincode: e.target.value });
            if (res.data !== null) {
                formik.setFieldValue('pincode_reponse', "success");
            } else {
                formik.setFieldValue('pincode_reponse', "not matched");
            }
            formik.setFieldValue('district', res.data.district_name);
            formik.setFieldValue('state', res.data.state_name);
            formik.setFieldValue('pincode_id', res.data.id);
            if (formik.values.national_pincode_id) {
                formik.setFieldValue('national_pincode_id', res.data.id);
            }
        } catch (error) {
            console.error('Pincode API Error:', error);
        }
    }

};